import React, { useState } from "react";
import api from "~/services/api";
import EditContent from "./EditContent";
import CreateContent from "./CreateContent";
import { LandPage, Container, Content, Main } from "./styles";
import {
  SLEditModal,
  SLCreateModal,
} from "~/pages/Sistema/componentes/SistemaList";
import TableComponent from "./TableComponent";

export default function Configuracoes() {
  const [mountedData, setMountedData] = useState();

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get(
                  '/signed/empresa/administracao/configuracoes',
                ),
              findOne: thisData =>
                api.get(
                  '/signed/empresa/administracao/configuracao',
                  { params: { id: thisData.id } },
                ),
              deleteOne: thisData =>
                api.delete(
                  '/signed/empresa/administracao/configuracao',
                  { data: { id: thisData.id } },
                ),
            }}
            informationPage={{
              title: 'Configurações',
              icone: 'submenu-configuracoes-azul',
            }}
          >
            <TableComponent />

            <SLEditModal
              title="Atualizar Item de Configuração"
              setter={setMountedData}
            >
              {mountedData && <EditContent {...{ mountedData }} />}
            </SLEditModal>

            <SLCreateModal title="Novo Item de Configuração">
              <CreateContent />
            </SLCreateModal>
          </Container>
        </div>
      </LandPage>
      <Content></Content>
    </Main>
  );
}
